import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClientLayout from './layout/ClientLayout';
import Clientroutesnodash from './routes/clientnodash'; // Public routes
import ClientRoutesWithDash from './routes/clientRoutes'; // Protected routes
// import Login from './views/clientviews/login'; // Public page
// import DashboardPage from './views/clientviews/Dashboardclient'; // Protected page
// import 'bootstrap-icons/font/bootstrap-icons.css';
import { PermissionProvider } from './contexts/PermissionContext';
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes (no authentication required) */}
        {Clientroutesnodash.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<route.element />}
          />
        ))}

        {/* Protected Routes (wrapped in PermissionProvider) */}
        <Route
          element={
            <PermissionProvider>
              <ClientLayout />
            </PermissionProvider>
          }
        >
          {ClientRoutesWithDash.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<ProtectedRoute element={<route.element />} />}
            />
          ))}
        </Route>
      </Routes>
    </Router>
  );
};

export default App;